import type { TieredPackageTier } from 'paintscout'
import { parseNumber } from './parse-number'

/**
 * Resolve a tier's total price from the base estimate price.
 *
 * - `percentage`: percent delta relative to base (e.g. -10 → base × 0.9)
 * - `value`: absolute target price. Non-positive targets are treated as "no
 *   adjustment" (resolve to base) so a missing/0 target can't silently zero out
 *   the quote.
 *
 * Shared by the calculator (`tierAdjustment`) and the builder (`getTierPrices`)
 * so the displayed tier prices and the applied total always agree.
 */
export function resolveTierPrice(basePrice: number, adjustment?: TieredPackageTier['adjustment']): number {
  if (!adjustment) {
    return basePrice
  }
  const value = parseNumber(adjustment.value)
  if (adjustment.type === 'percentage') {
    return basePrice * (1 + value * 0.01)
  }
  return value > 0 ? value : basePrice
}
